import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['featured']

  unselectOthers(e) {
    e.preventDefault();
    var newFeatured = e.target;

    for (let i = 0; i < this.featuredTargets.length; i++) {
      this.featuredTargets[i].checked = false;
    }
    e.target.checked = true;
  }
}
